import classNames from 'classnames';

/*
Uses @sm container query breakpoint (384px).
Shows desktop layout when container >= 384px.
Note: container query variants (e.g. @sm) only apply when an ancestor has className="sui-@container".
*/

export const showAboveSmBreakpoint = classNames(
  'sui-hidden',
  '@sm:sui-block'
);

export const showBelowSmBreakpoint = classNames(
  'sui-block',
  '@sm:sui-hidden'
);

export const showAboveSmBreakpointIf = (condition) => classNames('sui-hidden', { '@sm:sui-block': condition });

// Adding a custom class to a card overwrites the default classes
export const defaultCardContentProps = classNames(
  'sui-flex',
  'sui-overflow-hidden',
  'sui-p-4',
  'sui-gap-4',
  'sui-flex-col'
);

export const quoteTitleStyles = classNames(
  'sui-text-base',
  'sui-text-primary',
  'sui-capitalize'
);

export const quoteCardTitleStyles = classNames(
  'sui-text-2xl',
  '@5xl:sui-text-3xl',
  'sui-text-primary',
  'sui-font-display',
  'sui-capitalize'
);